import {StyleParamType, wixColorParam, createStylesParams} from '@wix/tpa-settings'

export type ImageStylesParams = {
  imageCornerRadiusTopLeft: StyleParamType.Number
  imageCornerRadiusTopRight: StyleParamType.Number
  imageCornerRadiusBottomLeft: StyleParamType.Number
  imageCornerRadiusBottomRight: StyleParamType.Number
  imageOpacity: StyleParamType.Number
  imageBehindColor: StyleParamType.Color
}

export const imageStylesParams = createStylesParams<ImageStylesParams>({
  imageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  imageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  imageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  imageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  imageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  imageBehindColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.06),
  },
})
